module.exports = __webpack_public_path__ + "static/media/marker-map.4f84755a.svg";